import React, { useEffect } from 'react'
import { observer, useLocalObservable } from 'mobx-react-lite'
import DraftInfluencer from '../models/DraftInfluencer'
import DraftUpload from '../models/DraftUpload'

export const DraftContext = React.createContext({})

export default observer(function DraftProvider({ children, selectedScenario }) {
  const draftState = useLocalObservable(() => (
    {
      influencers: [],
      actions: [],
      selectedActionIds: [],
      selectedUpload: new DraftUpload(),
      setSelectedUpload(upload) { this.selectedUpload = upload },
      commentable: false,
      toggleCommentable() { this.commentable = !this.commentable },
      isActionSelected(actionId) {
        return this.selectedActionIds.includes(+actionId)
      },
      toggleActionSelected(actionId) {
        actionId = +actionId
        this.selectedActionIds = this.isActionSelected(actionId)
          ? this.selectedActionIds.filter(id => id !== actionId)
          : [...this.selectedActionIds, actionId]
      },
    }
  ))

  const getActions = () => {
    if (!selectedScenario) return

    draftState.actions = selectedScenario.actions.filter(action => action.action_type !== 'non_media_item' && action.visible_in_budget)
    const infIds = [...new Set(draftState.actions.map(action => action.influencer_id))]
    draftState.influencers = infIds.map(id => new DraftInfluencer({ id }))
    setInfluencerActions()
  }

  const actionsForInfluencer = (influencerId) => {
    return draftState.actions.filter(action => +action.influencer_id === +influencerId)
  }

  const setInfluencerActions = () => {
    draftState.influencers.forEach(inf => {
      const inf_actions = actionsForInfluencer(inf.id)
      inf.username = inf_actions[0].auth_username
      inf.avatar = inf_actions[0].avatar
      inf.email = inf_actions[0].influencer_email
      inf.platforms = [...new Set(inf_actions.map(action => action.provider))]
    })
  }

  useEffect(() => getActions(), [selectedScenario?.id])

  return (
    <DraftContext.Provider
      value={{
        draftState: draftState,
        influencers: draftState.influencers,
        actions: draftState.actions,
        selectedUpload: draftState.selectedUpload,
        commentable: draftState.commentable,
        actionsForInfluencer,
      }}
    >
      {children}
    </DraftContext.Provider>
  )
})
